import { render, staticRenderFns } from "./CropInsecticides.vue?vue&type=template&id=ce560ca6&"
import script from "./CropInsecticides.vue?vue&type=script&lang=js&"
export * from "./CropInsecticides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports